<template>
    <div>
        <div class="content-box">
            <p>请 <span class="text-bold">检查核实</span> 调用计划的 <span class="text-bold">关键信息</span>，若发现有误请及时调整。</p>
            <p class="mb10">核实完成后请勿再修改调用计划相关信息，若需修改，在修改后需要刷新页面重新选择该计划。</p>

            <el-tabs type="card" v-model="activeName" @tab-click="handleClick" class="oppo-plan-tabs">
                <el-tab-pane :name="index.toString()" v-for="(eles, index) in list" :key="index">
                    <span slot="label">
                        <span :class="{ 'statusactive': !eles.check }">{{getLabel(eles)}}</span>
                    </span>
                </el-tab-pane>
            </el-tabs>

            <div class="plan-content">
                <div v-for="(eles, index) in list" :key="index">
                    <div v-if="activeName === index.toString()">
                        <el-row class="mb10 row-info">
                            <el-col :span="24">
                                <span class="label-text text-color-gray">计划名称：</span> {{eles.plan_info.planName||'--'}}（{{eles.plan_info.planId}}）
                            </el-col>
                            <el-col :span="12">
                                <span class="label-text text-color-gray">推广目标：</span> {{getExtensionTypeText(eles.plan_info.extensionType)}}
                            </el-col>
                            <el-col :span="12">
                                <span class="label-text text-color-gray">计划预算：</span> <span class="text-color-error text-bold">
                              <!--计划日限额:不限额显示-1，有限额以毫分为单位显示，1元=100000毫分-->
                            <span v-if="eles.plan_info.dayLimit==0">不限</span>
                            <span v-else>
                                 {{centToYuan(eles.plan_info.dayBudget)}}
                            </span>
                            </span>
                            </el-col>
                        </el-row>
                        <el-row class="mb10 row-info" v-for="item in eles.group_info" :key="item.id">
                            <el-col :span="24">
                                <span class="label-text text-color-gray">广告组名称：</span> {{item.adGroupName||'--'}}（{{item.adGroupId||'--'}}）
                            </el-col>
                            <el-col :span="12" class="ellipsis">
                                <span class="label-text text-color-gray">投放应用：</span>
                                <span v-if="item.targetType=='3'">
                                 {{item.instantAppName||'--'}}（{{item.instantAppId||'--'}}）
                            </span>
                                <span v-else>
                                 {{item.appName||'--'}}（{{item.appId||'--'}}）
                            </span>
                            </el-col>

                            <el-col :span="12">
                                <span class="label-text text-color-gray">定向包名称：</span> {{getTargetText(item.targetId)}}（{{item.targetId||'--'}}）
                            </el-col>

                            <el-col :span="12">
                                <span class="label-text text-color-gray">出价方式：</span> {{getBillingTypeText(item.billingType)}}
                            </el-col>
                            <el-col :span="12">
                                <span class="label-text text-color-gray">基础出价：</span> <span class="text-color-error text-bold">{{centToYuan(item.price)}}</span>
                            </el-col>

                            <el-col :span="12">
                                <span class="label-text text-color-gray">转化类型：</span> {{getOcpcTypeText(item.ocpcType)}}
                            </el-col>
                            <el-col :span="12">
                                <span class="label-text text-color-gray">转化出价：</span> <span class="text-color-error text-bold">{{item.ocpcType=='0'?'-':centToYuan(item.ocpcPrice)}}</span>
                            </el-col>

                            <el-col :span="12">
                                <span class="label-text text-color-gray">深度转化类型：</span> {{getDeepOcpcTypeText(item.deepOcpcType)}}
                            </el-col>
                            <el-col :span="12">
                                <span class="label-text text-color-gray">深度转化出价：</span> <span class="text-color-error text-bold">{{item.targetROI!=0?getTargetROIText(item.targetROI):(item.deepOcpcType=='0'?'-':centToYuan(item.deepOcpcPrice))}}</span>
                            </el-col>


                        </el-row>

                    </div>
                </div>

            </div>
        </div>
        <p class="dialog-footer tac mt20">
            <template v-for="(eles, index) in list">
                <el-button type="primary"
                           @click="submitModal(eles)" :loading="formLoading" class="action-btn ml20"
                           :disabled="eles.check"
                           v-show="activeName === index.toString()"
                           :key="index"
                           >已核实</el-button>
            </template>

        </p>
    </div>
</template>

<!-- 工单管理 批量下载弹框-->
<script>

import {cloneDeep} from 'lodash'
import API from '@/api/marketManage/oppoBatch';
export default {
    name: "oppoPlanModal",
    props:['cbs', 'propsData'],
    data(){
        return {
            activeName: '0',
            actionPlanInfo:{
                plan_info:{},
                group_info:[
                    {},
                ],
                target_info:[],
                task_id:'',
                map: {}
            },
            dataLoading:false,
            hasGroupTargetId:null,
            formLoading: false,
            list:[],
        }
    },
    watch: {
        'propsData': {
            handler(){
                this.checkPlanInfo()
            },
            immediate: true
        }
    },
    mounted(){
    },
    methods:{
        submitModal(params){
            let groupInfos = params.group_info||[];
            let groupPrices = groupInfos.filter(item=>{
                return item.ocpcType!='0';
            }).map(item=>{
                // 取 转化出价
                return this.centToYuan(item.ocpcPrice);
            });
            let isHasLowPrice = groupPrices.some(item=>!isNaN(item)&&item>0&&item<1.2);
            if(isHasLowPrice){
                let htmlStr = '<p>您当前转化出价低于<span class="text-color-error">1.2元</span>，请确认核实，以免创建失败！！</p>';
                this.$confirm(htmlStr,'温馨提示',{
                    confirmButtonText: '已确认',
                    cancelButtonText: '关闭',
                    dangerouslyUseHTMLString: true,
                    type: 'warning',
                }).then(()=>{
                    this.findErrorPlan(params)
                    // this.$emit('confirm',{
                    //     hasGroupTargetId:this.hasGroupTargetId,
                    //     taskId:this.actionPlanInfo.task_id,
                    //     appId:(groupInfos[0]||{}).appId,
                    // });
                    // this.handleClose();
                })
            }else{
                this.findErrorPlan(params)
                // this.$emit('confirm',{
                //     hasGroupTargetId:this.hasGroupTargetId,
                //     taskId:this.actionPlanInfo.task_id,
                //     appId:(groupInfos[0]||{}).appId,
                // });
                // this.handleClose();
            }
        },
        // 找到下一个有问题的计划， 没有就给我关闭弹框
        findErrorPlan(params){
            params.check = true;
            let current_no_check_index = this.list.findIndex(item=>item.check===false)
            if(current_no_check_index>-1){
                this.activeName = current_no_check_index.toString();
            }else{
                // 关闭
                this.cbs.confirm()
            }
        },
        hideModal(){
            this.$emit('close');
        },
        getLabel(item) {
            return `${item.plan_info.planName||'--'}（${item.plan_info.planId}）`
        },
        handleClick() {

        },
        handleClose(){
            this.dialogVisible = false;
            this.dataLoading = false;
            this.hasGroupTargetId = null;
            this.actionPlanInfo = {
                plan_info:{},
                group_info:[
                    {},
                ],
                task_id:'',
                target_info:[],
            };
        },
        checkPlanInfo(){
            let cloneDeep_propsData = cloneDeep(this.propsData)
            this.actionPlanInfo.task_id = cloneDeep_propsData.task_id;
            this.list = cloneDeep_propsData.list.map(item=>{
                item['check'] = false
                return {...item}
            });
            this.actionPlanInfo.map = cloneDeep_propsData.map;
        },
        getExtensionTypeText(type){
            let map = this.actionPlanInfo.map||{};
            let dataMap = map.extensionType||[];
            let actionItem = dataMap.find(item=>item.id == type);
            return actionItem?actionItem.name:'--';
        },
        getBillingTypeText(type){
            let map = this.actionPlanInfo.map||{};
            let dataMap = map.billingType||[];
            let actionItem = dataMap.find(item=>item.id == type);
            return actionItem?actionItem.name:'--';
        },
        getTargetText(id){
            let targetList = this.actionPlanInfo.target_info||[];
            let targetName = ''
                this.list.forEach(item=>item.target_info.forEach(targetItem=>{
                    if(targetItem.targetId==id) {
                        targetName = targetItem.targetName;
                    }
                }))
            console.log(id,targetList, this.list, targetName)
            return targetName ? targetName||'--':'--';
        },
        getOcpcTypeText(type){
            let map = this.actionPlanInfo.map||{};
            let dataMap = map.ocpcType||[];
            let actionItem = dataMap.find(item=>item.id == type);
            return actionItem?actionItem.name:'--';
        },
        getDeepOcpcTypeText(type){
            let map = this.actionPlanInfo.map||{};
            let dataMap = map.deepOcpcType||[];
            let actionItem = dataMap.find(item=>item.id == type);
            return actionItem?actionItem.name:'--';
        },
        getTargetROIText(num){
            if(isNaN(num)){
                return '--';
            }else{
                return +num/(100*10000).toFixed(2);
            }

        },
        centToYuan(num){
            if(!num||isNaN(num)) return num;
            let newNum = +num;
            if(num===0) return 0;
            if(num%100!=0){
                return (newNum/100).toFixed(2);
            }else{
                return newNum/100;
            }
        },

    }
}
</script>

<style lang="scss" scoped>
.plan-content{
    border: solid 1px #dcdee2;
    border-top: none;
    height: 300px;
    overflow-y: auto;
    padding: 20px;
    font-size: 12px;
}
.row-info{
    background-color: #f8f8f9;
    padding: 10px 20px;
    border-radius: 3px;
    line-height: 28px;
}
.label-text{
    display: inline-block;
    width: 8em;
    text-align: right;
    margin-right: 20px;
}

.confirm-btn{
    width: 150px;
}
.oppo-plan-tabs{
    ::v-deep.el-tabs__header{
        margin-bottom: 0;
    }
    .statusactive{
        color: #FF0000;
    }
    ::v-deep.is-active{
        .statusactive{
            color: #409EFF;
        }
    }
}
</style>

